import { useQuery } from '@tanstack/react-query';

import { useServicesContext } from '../../../contexts/ServicesContext';

export enum AnalyzationSummaryCacheKey {
  AnalyzationSummary = 'ANALYZED_SURVEY_SUMMARY',
}

export const useAnalyzationSummaryQuery = (
  teamId: number,
  surveyId: number,
) => {
  const { fetchAnalyzationSummary } = useServicesContext();
  return useQuery({
    queryKey: [AnalyzationSummaryCacheKey.AnalyzationSummary, teamId, surveyId],
    queryFn: () => fetchAnalyzationSummary(surveyId),
  });
};
